export type RuleStatus = 'saved' | 'changed' | 'new'

const SAVED = 'saved-'

// A draft rule loaded from storage carries its stored index in its key; any other key is new.
export const savedKey = (index: number) => `${SAVED}${index}`

export const newRuleKey = () => `new-${Date.now()}`

export function ruleStatus<R extends { key: string }, S>(
  rule: R,
  saved: S[],
  same: (rule: R, original: S | undefined) => boolean
): RuleStatus {
  if (!rule.key.startsWith(SAVED)) return 'new'
  return same(rule, saved[Number(rule.key.slice(SAVED.length))])
    ? 'saved'
    : 'changed'
}

// Edited and new rules, deleted ones, and one more when the kept ones changed order.
export function countRuleChanges<R extends { key: string }>(
  rules: R[],
  savedCount: number,
  status: (rule: R) => RuleStatus
) {
  const kept = rules
    .filter((rule) => rule.key.startsWith(SAVED))
    .map((rule) => rule.key)
  const edited = rules.filter((rule) => status(rule) !== 'saved').length
  const inOrder = Array.from({ length: savedCount }, (_, i) =>
    savedKey(i)
  ).filter((key) => kept.includes(key))
  return (
    edited +
    (savedCount - kept.length) +
    (kept.join() === inOrder.join() ? 0 : 1)
  )
}
